import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../services/firebase';
import { SPACES } from '../data/spaces';

const SpacesContext = createContext(SPACES);

export function SpacesProvider({ children }) {
  const [spaces, setSpaces] = useState(SPACES);

  useEffect(() => {
    getDoc(doc(db, 'config', 'spaces'))
      .then((snap) => {
        if (snap.exists()) setSpaces(snap.data().spaces);
      })
      .catch((err) => {
        console.error('[Firestore] SpacesContext load failed:', err);
      });
  }, []);

  return <SpacesContext.Provider value={spaces}>{children}</SpacesContext.Provider>;
}

export const useSpaces = () => useContext(SpacesContext);
